import React from "react";
import { Link } from "react-router-dom";
import { blogs } from "./../blogs"; // Import the blogs array from blogs.js

const BlogsArea = () => {
  return (
    <div className="vs-blog-wrapper space-top space-extra-bottom">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
            <div className="title-area">
              <span className="sec-subtitle">Explore Our Blog</span>
              <h2 className="sec-title h1">Insights, Tips & Stories</h2>
            </div>
          </div>
        </div>

        <div className="row gx-30">
          {blogs.map((blog) => (
            <div key={blog.id} className="col-xl-6 col-md-6 col-sm-12 col-12">
              <div className="vs-blog blog-style2">
                <div className="blog-img">
                  <Link to={`/blogs/blog-details/${blog.id}/`}>
                    <img
                      src={blog.mainImg} // Static image for simplicity
                      alt="blog"
                    />
                  </Link>
                  <div className="blog-inner-author">
                    <img
                      src="/img/user.jpg" // Static image for the author
                      alt="blog author"
                    />
                    <Link to="#" className="author-name">
                      {blog.authorName}
                    </Link>
                    <span className="author-degi">{blog.authorRole}</span>
                  </div>
                </div>
                <div className="blog-content">
                  <h2 className="blog-title">
                    <Link to={`/blogs/blog-details/${blog.id}/`}>
                      {blog.title}
                    </Link>
                  </h2>
                  <p>{blog.description}</p>
                  <div className="blog-bottom">
                    <Link
                      className="blog-date"
                      to={`/blogs/blog-details/${blog.id}/`}
                    >
                      <i className="fas fa-calendar-alt"></i> {blog.date}
                    </Link>
                    <Link
                      className="vs-btn has-arrow"
                      to={`/blogs/blog-details/${blog.id}/`}
                    >
                      Read More <i className="fal fa-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogsArea;
